class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    console.log('url',window.Shopify.routes.root + "search/suggest.json");
    const language = document.documentElement.lang;
    console.log(language)

    if(language == 'fr'){
       // fetch(`${window.Shopify.routes.root}search/suggest?q=${searchTerm}&section_id=predictive-search`)
    // fetch(`${window.Shopify.routes.root}search/suggest?q=${searchTerm}&section_id=predictive-search&locale=${document.documentElement.lang}`)
      
    fetch(`${window.Shopify.routes.root}search/suggest.json?q=${searchTerm}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`)
      .then((response) => response.json())
      .then((suggestions) => {
        console.log("Full API response:", suggestions);
    
        // Ensure results exist before accessing them
        const productSuggestions = suggestions.resources?.results?.products || [];
    
        if (productSuggestions.length > 0) {
          let resultsMarkup = `
            <div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper">
              <div class="predictive-search__result-group">
                <h4 id="predictive-search-queries" class="predictive-search__heading text-body caption-with-letter-spacing">
                  ${productSuggestions[0].collections?.[0]?.title || "Produits"}
                </h4>
                <ul id="predictive-search-results-queries-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-queries">
          `;
    
          productSuggestions.forEach((product) => {
            let imageSrc = product.images?.[0] || "https://via.placeholder.com/50";


              if(product.image){
      
                resultsMarkup += `
                  <li id="predictive-search-option-product-${product.id}" class="predictive-search__list-item" role="option" aria-selected="false">
                    <a href="${product.url}" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">
                      <div class="predictive-search__item-content">
                        <p class="predictive-search__item-heading h5">${product.title}</p>
                      </div>
                    </a>
                  </li>
                `;
              }
          });
    
          resultsMarkup += `
                </ul>
              </div>
            </div>
          `;
    
          const searchResultsContainer = this.predictiveSearchResults;
          if (searchResultsContainer) {
            searchResultsContainer.innerHTML = resultsMarkup;
            this.open();
          } else {
             this.close();
            console.warn("Predictive search container not found in the DOM.");
          }
        } else {
           this.close();
          console.warn("No product suggestions found.");
        }
      })
      .catch((error) => {
         this.close();
        console.error("Error fetching predictive search:", error);
      });



       
    }else{
      fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
        .then((response) => {
          console.log("response",response);
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          console.log("text",text);
          console.log("searchTerm",searchTerm);
          $(text).find(".predictive-search__list-item").each(function(){
            var thisText = $(this).find(".predictive-search__item-heading").text();
            console.log("thisText",thisText);
           $(this).find(".predictive-search__item-heading").addClass('hello');
            
          });
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }


  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('custom-predictive-search', PredictiveSearch);